import { defineMessages } from "react-intl";

export const messages = defineMessages({
  contentsPlaceholder: {
    id: "replyMessageFields.contents.placeholder",
    defaultMessage: "Reply...",
    description: "Placeholder for text field contents",
  },
  replyButton: {
    id: "replyMessageFields.button.submit",
    defaultMessage: "Reply",
    description: "Button label for reply",
  },
  delayedInfoText: {
    id: "replyMessageFields.delayedNotification.text",
    defaultMessage:
      "Notification of unread messages is sent to the recipient with a certain delay, in order to avoid sending too many notifications.",
    description: "Delayed notification info text",
  },
});
